import { Link, graphql, useStaticQuery } from "gatsby";
import React from "react";
import { FaDiscord, FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import "../styles/footer.css";

const Footer = () => {
    const siteMeta = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    copyright
                    social {
                        discord
                        facebook
                        twitter
                        instagram
                    }
                }
            }
        }
    `).site.siteMetadata;

    const iconsSize = 22;

    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="copyright">{siteMeta.copyright}</p>
                <div className="links">
                    <div className="socials">
                        <a href={siteMeta.social.discord} target="_blank" rel="noreferrer">
                            <FaDiscord size={iconsSize} />
                        </a>
                        <a href={siteMeta.social.facebook} target="_blank" rel="noreferrer">
                            <FaFacebook size={iconsSize} />
                        </a>
                        <a href={siteMeta.social.instagram} target="_blank" rel="noreferrer">
                            <FaInstagram size={iconsSize} />
                        </a>
                        <a href={siteMeta.social.twitter} target="_blank" rel="noreferrer">
                            <FaTwitter size={iconsSize} />
                        </a>
                    </div>
                    <div className="docs">
                        <Link to="/terms-of-use">Terms of Use</Link>
                        <Link to="/disclaimer">Disclaimer/Privacy Policy</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
